/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductImportViolation } from '../../models/product-import-violation';

export interface ImportExcel$Params {

/**
 * The id (i.e path/name) of imported image to aplye product import
 */
  key: string;

/**
 * The merchantId in case of EASYLOT_ADMIN
 */
  merchantIdParam?: string;
}

export function importExcel(http: HttpClient, rootUrl: string, params: ImportExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductImportViolation>>> {
  const rb = new RequestBuilder(rootUrl, importExcel.PATH, 'get');
  if (params) {
    rb.path('key', params.key, {});
    rb.query('merchantIdParam', params.merchantIdParam, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductImportViolation>>;
    })
  );
}

importExcel.PATH = '/import/excels/{key}/import';
